module.exports = __webpack_public_path__ + "img/id.7cc7871b.svg";